import { Actions } from './mobile-settings.actions'
import { fromJS } from 'immutable'
import * as MobileSettingsTypes from './mobile-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function mobileSettingsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case MobileSettingsTypes.UPDATE_MOBILE_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case MobileSettingsTypes.UPDATE_MOBILE_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case MobileSettingsTypes.UPDATE_MOBILE_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case MobileSettingsTypes.FETCH_MOBILE_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case MobileSettingsTypes.FETCH_MOBILE_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case MobileSettingsTypes.FETCH_MOBILE_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case MobileSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case MobileSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
